const _video = "16 / 9"
const _square = "1/1"
const _auto = "auto"
const config = { "video": _video, "square": _square, "auto": _auto, "4/3": "4 / 3", "3/4": "3 / 4", "9/4": "9 / 4",  }
export { config as default, _video, _square, _auto }